import React, { useEffect, useRef, useState } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { DATE_PRESETS, DEFAULT_PRESET, getPresetRange } from 'src/utils/date-presets';
import { useDashboardFilters } from './dashboard-filters-context';

const sameDay = (a, b) =>
  new Date(a).setHours(0, 0, 0, 0) === new Date(b).setHours(0, 0, 0, 0);

export default function AppDateRangePresets() {
  const {
    selectedStartTime,
    setSelectedStartTime,
    setSelectedEndTime,
    setRealTimeState,
    triggerRefresh,
  } = useDashboardFilters();

  const [activePreset, setActivePreset] = useState(DEFAULT_PRESET);
  const applyingRef = useRef(false);

  // Desmarca o preset se o usuário editar a data de início manualmente nos cards.
  useEffect(() => {
    if (applyingRef.current) {
      applyingRef.current = false;
      return;
    }
    if (!activePreset) return;
    const range = getPresetRange(activePreset);
    if (range && !sameDay(selectedStartTime, range.start)) {
      setActivePreset(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStartTime]);

  const handleChange = (event, key) => {
    if (!key) return;
    const range = getPresetRange(key);
    if (!range) return;
    applyingRef.current = true;
    setRealTimeState(false);
    setSelectedStartTime(range.start);
    setSelectedEndTime(range.end);
    setActivePreset(key);
    if (triggerRefresh) triggerRefresh();
  };

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={activePreset}
      onChange={handleChange}
      sx={{ flexWrap: 'wrap', gap: 1, '& .MuiToggleButton-root': { borderRadius: 1 } }}
    >
      {DATE_PRESETS.map((preset) => (
        <ToggleButton key={preset.key} value={preset.key}>
          {preset.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
